import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const ROAD_IMG =
  "https://images.unsplash.com/photo-1542169096-d626c9d082ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxlbXB0eSUyMHdpbmRpbmclMjByb2FkfGVufDB8fHx8MTc4NjMzMzM2Nnww&ixlib=rb-4.1.0&q=85&w=1800&auto=format&fit=crop";

export default function RoadParallax() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[70vh] overflow-hidden" data-testid="road-parallax">
      <motion.img
        src={ROAD_IMG}
        alt="Empty winding road stretching ahead"
        style={{ y }}
        className="absolute left-0 w-full h-[130%] object-cover -top-[15%]"
      />
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative h-full max-w-[1600px] mx-auto flex items-end px-6 md:px-12 pb-16 md:pb-24">
        <Reveal>
          <h2 className="font-cabinet font-black uppercase text-white text-4xl md:text-7xl tracking-tighter leading-[0.95]">
            Because learning to drive
            <br />
            <span className="text-[#F5B301]">is only the beginning.</span>
          </h2>
        </Reveal>
      </div>
    </section>
  );
}
